
import Vue from 'vue';
import { TeamMember } from '@run-diffusion/shared';
import { mapGetters, mapState } from 'vuex';
import ClipboardCopy from '@/components/ClipboardCopy.vue';

export default Vue.extend({
	name: 'RunnitBoardMemberJoinedStatus',
	props: {
		runnitMember: { type: Object, default: null },
		teamMember: { type: Object, default: null },
	},
	computed: {
		...mapState([
			'team',
		]),
		...mapGetters([
			'displayLabels',
		]),
	},
	methods: {
		buildTeamInviteLink(teamMember: TeamMember) {
			if (!this.team?.id || !teamMember?.inviteCode) {
				return '';
			}
			return `${window.location.origin}/team-signup?teamName=${encodeURIComponent(this.team.name)}&teamId=${this.team.id}&inviteCode=${teamMember.inviteCode}`;
		},
	},
	components: {
		ClipboardCopy,
	},
});
